// extracted by mini-css-extract-plugin
module.exports = {"page":"NN","account":"ON","pdp":"PN","cart":"QN","brand":"RN","cartModal":"SN","checkout":"TN"};